import React, { useState, useEffect } from "react";
import { Button, Icon } from "semantic-ui-react";
import { useParams, useHistory } from "react-router-dom";
import { size } from "lodash";
import { useProduct, useTable } from "../../hooks";
import { getProductsCart } from "../../api/cart";
import { ListProductCart } from "../../components/Client";

export function TableMenuCart() {
  const [products, setProducts] = useState(null);
  const [reloadCart, setReloadCart] = useState(false);
  const { getProductById } = useProduct();
  const { table, getTable } = useTable();
  const { id } = useParams();
  const history = useHistory();

  useEffect(() => {
    getTable(id);
  }, [id]);

  useEffect(() => {
    (async () => {
      const productsCart = getProductsCart();

      const productsArray = [];
      for await (const cartItem of productsCart) {
        const response = await getProductById(cartItem.id);
        productsArray.push({
          ...response,
          quantity: cartItem.quantity,
          note: cartItem.note,
          optionChoice: cartItem.optionChoice,
          extras: cartItem.extras,
          unitPrice: cartItem.unitPrice,
          offerId: cartItem.offerId,
          offerTitle: cartItem.offerTitle,
          takeaway: cartItem.takeaway,
          courtesy: cartItem.courtesy,
          courtesyReason: cartItem.courtesyReason,
        });
      }
      setProducts(productsArray);
    })();
  }, [reloadCart]);

  const onReloadCart = () => setReloadCart((prev) => !prev);
  const goToMenu = () => history.push(`/admin/table/${id}/menu`);

  return (
    <div>
      <Button icon labelPosition="left" onClick={goToMenu}>
        <Icon name="arrow left" />
        Regresar al Menu
      </Button>

      <h1>Carrito</h1>
      {!products || !table ? (
        <p>Cargando...</p>
      ) : size(products) === 0 ? (
        <div style={{ textAlign: "center" }}>
          <p>El carrito esta vacio</p>
        </div>
      ) : (
        <ListProductCart
          products={products}
          onReloadCart={onReloadCart}
          idTable={id}
          // WhatsApp (recoge), Venta rápida y Delivery salen empacados; el salón no.
          defaultTakeaway={table.kind !== "SALON"}
          redirectPath={`/admin/table/${id}`}
        />
      )}
    </div>
  );
}
